import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { Message } from "features/Application/components/Message/Message";

interface Props {
  action?: () => void;
}

export const EmbeddedVideoUnavailable: React.FC<Props> = props => {
  const { action } = props;
  const { t } = useTranslation("assets");

  return (
    <Message
      type="error"
      message={<Trans i18nKey={"embeddedVideos.notAvailable"} t={t} components={{ b: <b /> }} />}
      action={action && { text: t("embeddedVideos.actionText"), onClick: action }}
    />
  );
};
